import React from 'react';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

const FooterWrapper = styled.footer`
  background: ${({ theme }) => theme.navBackground};
  color: ${({ theme }) => theme.navTextColor};
  text-align: center;
  padding: 1.5rem 1rem;
  font-size: 1rem;
  border-top: 1px solid ${({ theme }) => theme.line || 'rgba(0,0,0,0.05)'};
`;

const FooterText = styled.p`
  margin: 0.5rem 0;
  letter-spacing: 0.06em;
  opacity: 0.78;
`;

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterText>© {year} Lukas Sivak. All rights reserved.</FooterText>
      <FooterText>Made with 💻, ☕, and maybe a bit of overthinking.</FooterText>
    </FooterWrapper>
  );
};

export default Footer;
